export const IMAGE_EXTENSIONS = ["jpg", "jpeg", "png", "gif"];
export const VIDEO_EXTENSIONS = ["mp4", "mov", "mpeg-1", "mpeg-2", "webm", "flv"];
export const DOCS_EXTENSIONS = ["doc", "docx"];
export const PDF_EXTENSION = "pdf";

export function getFileName(fileUrl) {
    return fileUrl.split("/").pop();
}

export function getFileExtension(fileName) {
    return fileName.split(".").pop().toLowerCase();
}

export function isImage(ext) {
    return IMAGE_EXTENSIONS.includes(ext);
}

export function isVideo(ext) {
    return VIDEO_EXTENSIONS.includes(ext);
}

export function isDoc(ext) {
    return DOCS_EXTENSIONS.includes(ext);
}

export function isPdf(ext) {
    return ext === PDF_EXTENSION;
}

export function getFileType(fileName) {
    const ext = getFileExtension(fileName);

    if (isImage(ext)) return "image";
    if (isVideo(ext)) return "video";
    if (isPdf(ext)) return "pdf";
    if (isDoc(ext)) return "doc";
    return null;
}
